import { createContext } from 'react';

const ChartContext = createContext(null);

export default ChartContext;
